import ApiClient from "../api-client";
import { EnvType } from "../services";
import HlsChunkerApiClient from "./hls-chunker-api-client";

export default class HlsChunkerService {
  hlsChunkerApiClient: HlsChunkerApiClient;

  constructor(envType: EnvType) {
    this.hlsChunkerApiClient = new HlsChunkerApiClient(new ApiClient(envType), envType);
  }

  //------Utils------
  GetServiceUrl(): string {
    return this.hlsChunkerApiClient.GetApiUrl();
  }
}
